<template>
  <qx-card-form title="车辆图片" v-show="showComponent" :defaultContentShow="false">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px"></qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import {
  getFileUrl,
} from 'api';
import { attachmentFiles, refreshUploadFiles } from '../attachmentFiles';

const aImgName = ['carRegistrationPictureList', 'vehiclePictureList'];
export default {
  data () {
    return {
      showComponent: false,
      baseForm: {
        inline: true,
        form: [
          {
            label: '车辆登记证书图片',
            value: 'carRegistrationPictureList',
            type: 'img',
            accept: 'image/*',
            fileSize: 51200000000,
            attr: {
              limit: 2,
            },
            default: [],
            hide: false,
          },
          {
            label: '车辆图片',
            value: 'vehiclePictureList',
            type: 'img',
            accept: 'image/*',
            fileSize: 51200000000,
            attr: {
              limit: 1,
            },
            default: [],
            hide: false,
          },
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    // 统一处理数据格式
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        if (this.showComponent) {
          // 讲需要提交的图片字段放进 formData 对象里面
          for (let imgItem of aImgName) {
            formData[imgItem] = await refreshUploadFiles(formData[imgItem] || []);
            // 获取要提交的字段名，例如这里是将 drivingLicenseList 截取成 drivingLicense
            let imgField;
            if (imgItem === 'vehiclePictureList') {
              imgField = 'vehiclePic';
            } else {
              imgField = imgItem.substring(imgItem.indexOf('List'), 0);
            }
            // 如果 drivingLicenseList 数组里面有图片，则将数组里面的图片id 赋值给 drivingLicense，用于提交和缓存数据
            if (formData[imgItem] && formData[imgItem].length) {
              if (imgItem === 'vehiclePictureList') {
                formData.vehiclePicture = formData[imgItem][0].id;
                formData[imgField + 'Url'] = formData[imgItem][0].url;


              } else {

                formData[imgField] = formData[imgItem][0].id;
                formData[imgField + 'Url'] = formData[imgItem][0].url;

                if (formData.carRegistrationPictureList && formData.carRegistrationPictureList.length) {
                  let imgIds = [];
                  let imgUrls = [];
                  formData.carRegistrationPictureList.forEach((item) => {
                    imgIds.push(item.id);
                    imgUrls.push(item.url);
                  });
                  formData.carRegistrationPicture = imgIds.join(',');
                  formData.carRegistrationPictureUrl = imgUrls.join(',');
                }
              }
            } else {
              imgItem === 'vehiclePictureList' ? formData.vehiclePicture = '' : formData[imgField] = '';
              formData[imgField + 'Url'] = '';
            }
          }
        } else {
          formData = {};
        }

      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        delete formData.carRegistrationPictureList;
        delete formData.vehiclePictureList;
      }
      return formData;
    },
    async init (data = {}) {
      if (data.trailerRel) {
        data.carRegistrationPicture = data.trailerRel.carRegistrationPicture;
        data.carRegistrationPictureUrl = data.trailerRel.carRegistrationPictureUrl;
        data.vehiclePicture = data.trailerRel.vehiclePicture;
        data.vehiclePictureUrl = data.trailerRel.vehiclePictureUrl;
      }
      this.$refs.baseForm.reset();
      // 重置表单为初始状态
      const vehicleClass = data.vehicleClass === null || data.vehicleClass === undefined ? (data.trailerRel || {}).vehicleClass : data.vehicleClass;
      this.resetBaseForm(vehicleClass);

      let flowIds = [];
      for (let imgItem of aImgName) {
        // 获取详情接口返回的的字段名，例如这里是将 drivingLicenseList 截取成 drivingLicense
        const imgField = imgItem.substring(imgItem.indexOf('List'), 0);
        // 例如 drivingLicense 有图片id值，代表有图片，传图片id到另外一个接口获取图片url
        if (data[imgField]) {
          flowIds.push(data[imgField]);
        } else {
          // 如果没有数据，则设置为空数组，防止报错
          data[imgItem] = [];
        }
      }
      if (flowIds.length) {
        const imgRes = await getFileUrl({
          flowIds: flowIds.join(),
        });
        for (let imgItem of aImgName) {
          const imgField = imgItem.substring(imgItem.indexOf('List'), 0);
          data[imgItem] = attachmentFiles(data[imgField], imgRes);
        }

      }
      this.$refs.baseForm.setVal(data);
    },
    // 设置所有表单
    resetBaseForm (vehicleClass) {
      this.showComponent = String(vehicleClass) === '1';
    },
    formChange (vehicleClass) {
      this.resetBaseForm(vehicleClass);
    },
    receivedData (vehicleClass) {
      this.formChange(vehicleClass);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
